module.exports = __webpack_public_path__ + "assets_1777427128813/img/pic_9.d436e297.png";